import { converge, path, pipe, prop, split } from 'ramda';

// eslint-disable-next-line import/prefer-default-export
export const fetchValue = converge(path, [
  pipe(prop('key'), split('.')),
  prop('values'),
]);
